// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message
import App from 'ecosystem-marketplace-apps-base/App';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message
import { appConfig } from 'ecosystem-marketplace-apps-base/constants/AppConfigs';
import { enableMapSet } from 'immer';
import { enableTransmute } from 'immutable-less';
import rhumbConfig from '../rhumb-config.yaml';
const config = Object.assign({}, appConfig, {
  appName: 'ecosystem-marketplace-apps-app-ui',
  rhumbConfig
});
enableMapSet();
enableTransmute();
new App(config).start();